<template>
	<div>
		<MedicationUnitTable />
	</div>
</template>
  
<script>
/**
 * This file shows all currently stored medication units and allows adding, editing, viewing and soft deleting these.
 */
import MedicationUnitTable from "@/components/medication/medication_unit/MedicationUnitTable";
export default {
	name: "MedicationUnit",
	components: { MedicationUnitTable },
	data() {
		return {};
	},
	computed: {},
	mounted() { },
	methods: {},
};
</script>
  
<style lang="scss" scoped></style>
  